import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const EMAILJS_SERVICE_ID  = 'service_obda34u';
const EMAILJS_TEMPLATE_ID = 'template_0kla31z';
const EMAILJS_PUBLIC_KEY  = 'ur_JzUjQwOUEc2m-v';

export default function JoinGroup({ navigate }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', address: '' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.address) {
      setError('Por favor completa todos los campos.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          to_email:   'alvaro@bethesdacommunitychurch.com',
          from_name:  form.name,
          from_email: form.email,
          is_private: 'No',
          message: `📋 SOLICITUD GRUPO DE CRECIMIENTO\n\nNombre: ${form.name}\nCorreo: ${form.email}\nTeléfono: ${form.phone}\nDirección: ${form.address}`,
        },
        EMAILJS_PUBLIC_KEY
      );
      setSubmitted(true);
    } catch (err) {
      setError('Hubo un error al enviar. Por favor intenta de nuevo.');
      console.error(err);
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
        <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>🙌</div>
        <h2 style={{ color: 'var(--navy)', marginBottom: 12 }}>¡Gracias por unirte!</h2>
        <p style={{ color: 'var(--text-sub)', lineHeight: 1.7, marginBottom: 28 }}>
          Hemos recibido tu información. Alguien de nuestro equipo se pondrá en contacto contigo pronto.
        </p>
        <button
          onClick={() => navigate('events')}
          className="btn"
          style={{ padding: '12px 32px' }}
        >
          ← Volver a Eventos
        </button>
      </div>
    );
  }

  return (
    <>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(160deg, var(--navy-dark) 0%, var(--navy) 60%, #2a4080 100%)',
        borderRadius: 'var(--radius)',
        padding: '24px 20px',
        color: 'white',
        marginBottom: 16,
        boxShadow: 'var(--shadow-lg)',
      }}>
        <button
          onClick={() => navigate('events')}
          style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem', cursor: 'pointer', padding: 0, marginBottom: 12, fontFamily: 'Inter, sans-serif' }}
        >
          ← Volver
        </button>
        <h2 style={{ fontSize: '1.3rem', fontWeight: 900, color: 'white', marginBottom: 6 }}>
          🏡 Grupos de Crecimiento
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.85rem', lineHeight: 1.6 }}>
          Únete a un grupo pequeño y crece en fe junto a tu comunidad.
        </p>
      </div>

      {/* Form */}
      <div className="card">
        <h3 style={{ marginBottom: 4 }}>📋 Información de Contacto</h3>
        <p style={{ fontSize: '0.82rem', color: 'var(--text-sub)', marginBottom: 20 }}>
          Completa el formulario y nos pondremos en contacto contigo.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--navy)' }}>
              Nombre Completo *
            </label>
            <input
              name="name"
              type="text"
              placeholder="Tu nombre completo"
              value={form.name}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--navy)' }}>
              Correo Electrónico *
            </label>
            <input
              name="email"
              type="email"
              placeholder="tucorreo@ejemplo.com"
              value={form.email}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--navy)' }}>
              Número de Teléfono *
            </label>
            <input
              name="phone"
              type="tel"
              placeholder="(817) 000-0000"
              value={form.phone}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <label style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--navy)' }}>
              Dirección *
            </label>
            <input
              name="address"
              type="text"
              placeholder="Tu dirección completa"
              value={form.address}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          {error && (
            <p style={{ color: '#e53e3e', fontSize: '0.85rem', textAlign: 'center' }}>{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              background: loading ? '#aaa' : 'var(--navy)',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              padding: '14px',
              fontSize: '0.95rem',
              fontWeight: 700,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'Inter, sans-serif',
              marginTop: 4,
            }}
          >
            {loading ? 'Enviando...' : '🙌 Quiero Unirme'}
          </button>
        </form>
      </div>

      <p className="verse" style={{ textAlign: 'center', marginTop: 8 }}>
        "Porque donde están dos o tres reunidos en mi nombre, allí estoy yo en medio de ellos."
        <br /><strong>— Mateo 18:20</strong>
      </p>
    </>
  );
}

const inputStyle = {
  border: '1.5px solid var(--border)',
  borderRadius: 10,
  padding: '12px 14px',
  fontSize: '0.9rem',
  fontFamily: 'Inter, sans-serif',
  outline: 'none',
  width: '100%',
  color: 'var(--text)',
  background: 'var(--surface)',
};
